import React from 'react';
import { useTranslation } from 'react-i18next';
import { Ban } from 'lucide-react';

/**
 * 图片禁用遮罩：灰色蒙层 + 右上角禁用角标，点击角标恢复使用。
 */
export default function IpeGalleryDisabledOverlay({ onRestore, showRestore = true }) {
  const { t } = useTranslation('workbench');
  return (
    <div className="ipe-gallery-disabled-overlay" aria-live="polite">
      <div className="ipe-gallery-disabled-overlay__mask" aria-hidden="true" />
      {showRestore ? (
        <button
          type="button"
          className="ipe-gallery-disabled-overlay__badge"
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            onRestore?.();
          }}
          aria-label={t('studioChrome.restoreUse')}
          title={t('studioChrome.restoreUse')}
        >
          <Ban size={16} aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
}
